module.exports = __webpack_public_path__ + "static/img/cinema-17.b38b30c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/png-img/cinema-17.png
// module id = 1197
// module chunks = 173